var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
export function SelectWithLabel(props) {
    var label = props.label, className = props.className, options = props.options, selectProps = __rest(props, ["label", "className", "options"]);
    return (_jsxs(StyledTextAreaWithLabel, __assign({ className: className }, { children: [label ? _jsx("h5", { children: label }, void 0) : null,
            _jsx("select", __assign({}, selectProps, { children: options.map(function (o) { return (_jsx("option", __assign({ value: o.id, disabled: !!o.disabled }, { children: o.label }), o.id)); }) }), void 0)] }), void 0));
}
var StyledTextAreaWithLabel = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 1.6rem;\n  h5 {\n    margin-bottom: 8px;\n    margin-top: 0;\n  }\n  select {\n    box-sizing: border-box;\n    font-size: 1.6rem;\n    padding: 10px;\n    background: #fbfbfb;\n    border: solid 1px #d8d8d8;\n    border-radius: 5px;\n    opacity: 0.5;\n    margin-bottom: 30px;\n    color: black;\n    width: 100%;\n    &:focus {\n      opacity: 1;\n    }\n  }\n"], ["\n  font-size: 1.6rem;\n  h5 {\n    margin-bottom: 8px;\n    margin-top: 0;\n  }\n  select {\n    box-sizing: border-box;\n    font-size: 1.6rem;\n    padding: 10px;\n    background: #fbfbfb;\n    border: solid 1px #d8d8d8;\n    border-radius: 5px;\n    opacity: 0.5;\n    margin-bottom: 30px;\n    color: black;\n    width: 100%;\n    &:focus {\n      opacity: 1;\n    }\n  }\n"])));
var templateObject_1;
